import React, { useState, useEffect } from 'react'
import { useNavigation, useShow, useGetIdentity, useUpdate } from '@pankod/refine-core'
import {
  Table,
  Typography,
  Icons,
  ShowButton,
  TabPaneProps,
  TableColumnType,
  Button,
  Badge,
  Tag,
  Space,
  EditButton,
  useModalForm,
  List,
  RefreshButton,
  notification,
  useTable,
  Form,
  Input,
  Popconfirm,
} from '@pankod/refine-antd'
import ReactMarkdown from 'react-markdown'
import { ReactMarkdownAllowedElements } from 'helpers/markdownConfig'

import { TableColumnsType } from 'antd'
import { IQuestion } from 'interfaces'
import questionMetadata from 'metadata/questions'
import { useUserContext } from 'context/user'
import Permissions from 'permissions'
import { MarkRetired } from 'components/questions/mark_retired'
import { createLogRePublished, updateQuestionInCleanup } from 'gql/mutations'
import RichTextRender from 'components/questions/rich_text_render'
type Props = {}
type Permission = {
  granted?: boolean
}

export const CleanupListPage = (props: Props) => {
  const { show, push } = useNavigation()
  const { data: user } = useGetIdentity()
  const { Text } = Typography
  const { userRole } = useUserContext()
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [currentRecord, setCurrentRecord] = useState('')
  const { mutateAsync: updateQuestionAsync, isSuccess } = useUpdate<IQuestion>()

  //access control
  const [readPermission, setReadPermission] = useState<Permission>({})
  const [createPermission, setCreatePermission] = useState<Permission>({})
  const [editPermission, setEditPermission] = useState<Permission>({})
  const [deletePermission, setDeletePermission] = useState<Permission>({})
  useEffect(() => {
    if (userRole !== undefined) {
      setReadPermission(Permissions.can(userRole).readAny('cleanup'))
      setCreatePermission(Permissions.can(userRole).createAny('cleanup'))
      setEditPermission(Permissions.can(userRole).updateAny('cleanup'))
      setDeletePermission(Permissions.can(userRole).deleteAny('cleanup'))
    }
  }, [userRole])

  useEffect(() => {
    if (!readPermission?.granted && readPermission?.granted !== undefined && userRole !== 'admin' && userRole !== 'qbincharge') push('/')
    console.log(readPermission, 'readpermission')
  }, [readPermission])

  // const { setShowId, queryResult } = useShow()
  // const { data: showQueryResult } = queryResult
  // const record = showQueryResult?.data
  //view available questions
  const { tableQueryResult, searchFormProps, setFilters } = useTable<IQuestion>({
    resource: 'questions',
    metaData: questionMetadata,
    permanentFilter: [
      { field: 'qb_permit', operator: 'eq', value: false },
      { field: 'status', operator: 'ne', value: 'Retired' },
    ],
    hasPagination: true,
    onSearch(data: any) {
      return [{ field: 'title', operator: 'contains', value: `%${data?.title}%` }]
    },
  })
  console.log('Review questions', tableQueryResult?.data?.data)
  // const {
  //   modalProps: editModalProps,
  //   formProps: editFormProps,
  //   show: editShow,
  // } = useModalForm({ metaData: questionMetadata, resource: 'questions', action: 'edit', redirect: false })
  const showModal = (id: string) => {
    setCurrentRecord(id)
    setIsModalVisible(true)
  }
  const handleOk = () => {
    setIsModalVisible(true)
  }
  const handleCancel = () => {
    setIsModalVisible(false)
  }
  const handleEnableQuestion = async (record: IQuestion) => {
    if (record?.id) {
      await updateQuestionAsync(
        {
          id: record?.id,
          resource: 'questions',
          metaData: { fields: ['id', 'title', 'question_id'] },
          values: { qb_permit: true },
          successNotification(data: any, values, resource) {
            return {
              message: `question ID: ${data?.question_id} sent back`,
              description: 'Question has been re-enabled for use',
              key: data?.id,
              type: 'success',
            }
          },
        },
        {
          onSuccess(data: any, variables, context) {
            console.log('these returned', data, variables, context)
            notification.success({
              message: `Question ID: ${data?.data?.question_id} sent back`,
              description: 'Question has been re-enabled for use',
              key: data?.id,
              type: 'success',
              duration: 5,
            })
          },
        }
      )
      await createLogRePublished(user?.id, record?.work_request, record?.id, record?.paper)
      // isSuccess ? notification.success({ message: `$question with ID ${record?.question_id} made available for use` }) : null
      // await createLogPublished(user?.id, record?.work_request, record?.id, record?.paper)
      // await createLogActivateDeactivate(user?.id, record?.work_request, record?.id, record?.paper, 'active')
      // updateQuestionStatus(record?.id, 'Published').then(() => {
      //   createLogPublished(user?.id, record?.work_request, record?.id, record?.paper)
      // })
      await updateQuestionInCleanup(record?.id)
    }
    // queryResult?.refetch()
  }
  const columns: TableColumnsType<IQuestion> = [
    {
      dataIndex: 'question_id',
      title: 'Id',
      fixed: 'left',
      width: 100,
    },

    {
      title: 'Name',
      dataIndex: 'name',
      fixed: 'left',
      width: 200,
      render: (_, record) => (
        <ShowButton
          size="small"
          type="link"
          icon={null}
          recordItemId={record?.id}
          onClick={() => {
            show('cleanup', record?.id)
          }}
        >
          <Text
            style={{
              // width: 150,
              textAlign: 'left',
              color: '#6659FF',
              cursor: 'pointer',
            }}
            ellipsis={{ tooltip: record?.title }}
          >
            {/* <ReactMarkdown
              allowedElements={ReactMarkdownAllowedElements}
              components={{
                p: ({ node, ...props }) => <p style={{ margin: '0' }} {...props} />,
                em: ({ node, ...props }) => <em style={{ margin: '0' }} {...props} />,
                strong: ({ node, ...props }) => <strong style={{ margin: '0' }} {...props} />,
                ol: ({ node, ...props }) => <ol style={{ margin: '0' }} {...props} />,
                ul: ({ node, ...props }) => <ul style={{ margin: '0' }} {...props} />,
                li: ({ node, ...props }) => <li style={{ margin: '0' }} {...props} />,
              }}
            >
              {record?.title.length < 30 ? record?.title.substring(0, 30) : record?.title.substring(0, 30).concat('...')}
            </ReactMarkdown> */}
            <RichTextRender content={record?.title} />
          </Text>
        </ShowButton>
      ),
    },
    {
      dataIndex: 'question_type_id',
      title: 'Q Type',
    },
    {
      dataIndex: 'grade_ids',
      title: 'Grade',
      render: (_, { question_grades, grade_ids }) => (
        <>
          {question_grades?.length > 0 ? (
            <div>
              {question_grades?.length > 1 ? (
                <Badge size="small" count={question_grades?.length - 1} style={{ background: '#6659ff' }}>
                  {/* <Tooltip title="prompt text" color={'#6659ff'} key={'#6659ff'}> */}
                  <Tag color={'blue'} key={question_grades?.[0]?.grade?.name}>
                    {question_grades?.[0]?.grade?.name}
                  </Tag>
                  {/* </Tooltip> */}
                </Badge>
              ) : (
                <Tag color={'blue'} key={question_grades?.[0]?.grade?.name}>
                  {question_grades[0]?.grade?.name}
                </Tag>
              )}
            </div>
          ) : null}
        </>
      ),
    },
    {
      dataIndex: 'topic_id',
      title: 'Topic',
      render: (_, record) => (
        <Text style={{ width: 175, textAlign: 'left' }} ellipsis={{ tooltip: record?.topic?.name }}>
          {record?.topic?.name}
        </Text>
      ),
    },
    {
      dataIndex: 'work_request',
      title: 'WR/Paper Name',
      render: (_, record) =>
        record?.work_request?.name ? (
          <Text style={{ width: 100, textAlign: 'left' }} ellipsis={{ tooltip: record?.work_request?.name }}>
            {record?.work_request?.name}
          </Text>
        ) : (
          <Text style={{ width: 100, textAlign: 'left' }} ellipsis={{ tooltip: `#${record?.paper?.paper_id} ${record?.paper?.paper_smart_id}` }}>
            {record?.paper?.paper_smart_id}
          </Text>
        ),
    },
    {
      dataIndex: 'status',
      title: 'Status',
      width: 100,
      className: 'ant-table-column-sort',
      render: value => (
        <Tag
          color={
            value === 'Published'
              ? 'green'
              : value === 'Rejected at Review' || value === 'Rejected at Approval' || value === 'Retired'
              ? 'volcano'
              : value === 'Open (Require Amending)' || value === 'For Review (Require Amending)'
              ? 'pink'
              : 'geekblue'
          }
        >
          {value}
        </Tag>
      ),
    },
    {
      dataIndex: 'qb_permit',
      title: 'QB Edit',
      render: (value, record) => <Tag color={value ? 'green' : 'volcano'}>{value ? 'Enabled' : 'Disabled'}</Tag>,
    },
    {
      dataIndex: 'creator_id',
      title: 'Creator',

      render: (_, record) => (
        <Text style={{ textAlign: 'left' }} ellipsis={{ tooltip: record?.userByCreatorId?.displayName }}>
          {record?.userByCreatorId?.displayName}
        </Text>
      ),
    },
    {
      dataIndex: 'reviewer_id',
      title: 'Reviewer',
      render: (_, record) => (
        <Text style={{ textAlign: 'left' }} ellipsis={{ tooltip: record?.userByReviewerId?.displayName }}>
          {record?.userByReviewerId?.displayName}
        </Text>
      ),
    },
    {
      dataIndex: 'approver_id',
      title: 'Approver',
      render: (_, record) => (
        <Text style={{ textAlign: 'left' }} ellipsis={{ tooltip: record?.userByApproverId?.displayName }}>
          {record?.userByApproverId?.displayName}
        </Text>
      ),
    },
    {
      dataIndex: 'Action',
      title: 'Action',
      fixed: 'right',
      width: userRole === 'qbincharge' ? '14%' : '7%',
      align: 'center',
      render: (_, record) => (
        <Space>
          {userRole === 'qbincharge' && record?.status !== 'Retired' ? (
            <Button type="primary" size="small" danger onClick={() => showModal(record?.id)}>
              Mark Retired
            </Button>
          ) : null}
          {(userRole === 'qbincharge' || userRole === 'admin') && (
            <Popconfirm
              title="Approve this question to be reused ?"
              okText="Approve"
              cancelText="Cancel"
              placement="left"
              onConfirm={() => {
                record && handleEnableQuestion(record)
              }}
            >
              <Button
                size="small"
                type="primary"
                key="republish"
                // disabled={record?.status === 'Published'}
              >
                Send Back
              </Button>
            </Popconfirm>
          )}
        </Space>
      ),
    },
    // {
    //   title: 'Actions',
    //   dataIndex: 'actions',
    //   render: (_, record) => (
    //     <Space>
    //       {userRole === 'admin' ||
    //       (userRole === 'variantcreator' && (record?.status === 'Open' || record?.status === 'Open (Require Amending)')) ||
    //       (userRole === 'qcreator' && (record?.status === 'Open' || record?.status === 'Open (Require Amending)')) ||
    //       (userRole === 'qreviewer' && (record?.status === 'For Review' || record?.status === 'For Review (Require Amending)')) ||
    //       (userRole === 'qapprover' && record?.status === 'For Approval') ? (
    //         <EditButton
    //           key="edit"
    //           size="small"
    //           type="link"
    //           hideText
    //           recordItemId={record.id}
    //           onClick={() => {
    //             editShow(record?.id)
    //             setShowId(record?.id)
    //           }}
    //         />
    //       ) : null}
    //       {userRole === 'qbincharge' && record?.status !== 'Retired' ? (
    //         <Button type="primary" onClick={() => showModal(record?.id)}>
    //           Mark Retired
    //         </Button>
    //       ) : null}
    //     </Space>
    //   ),
    // },
  ]
  return (
    <List
      title="Questions"
      headerProps={{
        extra: (
          <>
            <RefreshButton onClick={() => tableQueryResult?.refetch()}></RefreshButton>
          </>
        ),
      }}
    >
      {' '}
      <Form {...searchFormProps}>
        <Space>
          <Form.Item name="title">
            <Input placeholder="Search by Question Title" />
          </Form.Item>
          <Button type="primary" icon={<Icons.SearchOutlined />} onClick={searchFormProps.form?.submit}>
            Search
          </Button>
          <Button
            onClick={() => {
              searchFormProps?.form?.setFieldsValue({ name: '' })
              searchFormProps.form?.submit()
            }}
          >
            Clear
          </Button>
        </Space>
      </Form>
      <Table dataSource={tableQueryResult?.data?.data} columns={columns} size="small" scroll={{ x: 1500 }} loading={tableQueryResult?.isLoading} />
      <MarkRetired isModalVisible={isModalVisible} handleOk={handleOk} handleCancel={handleCancel} id={currentRecord} />
    </List>
  )
}
